// ── imports explicites (Phase 4B, générés puis maintenus à la main) ──

// ═══════════════════════════════════════════════════════════════════════════
//  OBSERVABILITÉ — collecteur d'erreurs client (in-house, zéro tiers)
//
//  Remonte les erreurs JS réelles vers le RPC serveur `log_client_error`
//  (SECURITY DEFINER, table client_errors non lisible côté client). But :
//  ne plus découvrir les bugs par hasard.
//
//  GARANTIES (par conception) :
//   • BLINDÉ : tout est en try/catch — le collecteur ne peut JAMAIS casser l'app
//     ni se déclencher lui-même en boucle (try/catch autour de l'envoi).
//   • VIE PRIVÉE : scrub strict avant envoi (emails, uuid, jetons, longs nombres,
//     query-string retirée → on ne garde que la route). Aucune PII stockée.
//   • EGRESS : circuit-breaker (≤ MAX_PER_SESSION envois/session) + dédup par
//     signature en session → un bug en boucle = 1 seul envoi. fetch keepalive.
//   • ADDITIF : CHAÎNE window.onerror / onunhandledrejection existants (n'écrase
//     rien), ne touche aucun flux, aucune donnée, aucun rendu. Se désinstalle de
//     fait si la config Supabase est absente.
//
//  Placé tôt dans le manifeste (après 00-boot) → les handlers s'installent avant
//  le rendu de l'app. N'utilise QUE des globals (window.LANAC_*) + fetch : robuste
//  même si supabase-js ou l'app sont cassés.
// ═══════════════════════════════════════════════════════════════════════════
(function installLanacErrorReporter() {
  try {
    var URL_BASE = window.LANAC_SUPABASE_URL;
    var ANON = window.LANAC_SUPABASE_ANON_KEY;
    if (!URL_BASE || !ANON) return; // pas de config → on n'installe rien

    var MAX_PER_SESSION = 12;  // au-delà : silence (anti-flood/egress)
    var sent = 0;
    var seenSig = Object.create(null); // dédup en session

    var BUILD = (function () {
      try {
        var s = Array.prototype.slice.call(document.scripts).map(function (x) { return x.src || ""; })
          .filter(function (u) { return /app\.[0-9a-f]{6,}\.js/.test(u); })[0] || "";
        var m = s.match(/app\.([0-9a-f]{6,})\.js/);
        return m ? m[1] : "";
      } catch (e) { return ""; }
    })();

    // ── Scrub : ne garder que la ROUTE (pas de query/ids), retirer toute PII ──
    function scrubRoute(u) {
      try { return new window.URL(u, location.href).pathname.slice(0, 180); } catch (e) { return ""; }
    }
    function scrub(s, max) {
      if (s == null) return "";
      s = String(s).slice(0, max || 2000);
      s = s.replace(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi, "[email]");         // emails
      s = s.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, "[uuid]"); // uuid
      s = s.replace(/eyJ[A-Za-z0-9_.-]{10,}/g, "[token]");                          // jwt/tokens
      s = s.replace(/\b\d{12,}\b/g, "[num]");                                       // longs nombres (cartes, tél)
      return s;
    }
    function sigOf(kind, msg, src) {
      return (kind + "|" + String(msg || "").slice(0, 140) + "|" + String(src || "")).slice(0, 200);
    }

    // ── Envoi (fire-and-forget, blindé) ──
    function report(kind, msg, opt) {
      try {
        // ⭐ 28/08 (audit) : un navigateur AUTOMATISÉ ne rapporte pas à la télémétrie de
        //  PROD — le harnais e2e (HeadlessChrome) avait injecté 515 occurrences d'une
        //  signature i18n dans client_errors, du bruit d'instrument classé « utilisateur ».
        //  `navigator.webdriver` est le standard W3C : vrai sous tout pilotage automatisé,
        //  jamais chez un utilisateur réel. La console, elle, reste observée par S5.
        if (navigator.webdriver === true) return;
        if (sent >= MAX_PER_SESSION) return;
        opt = opt || {};
        var m = scrub(msg, 2000);
        var src = opt.src ? scrubRoute(String(opt.src).split("?")[0]) : "";
        var sig = sigOf(kind, m, src);
        if (seenSig[sig]) return;   // 1× par signature/session
        seenSig[sig] = 1;
        sent++;
        var body = JSON.stringify({
          p_kind: String(kind).slice(0, 40),
          p_message: m,
          p_stack: scrub(opt.stack, 4000),
          p_route: scrubRoute(location.href),
          p_signature: sig,
          p_ua: String(navigator.userAgent || "").slice(0, 180),
          p_app: BUILD
        });
        fetch(URL_BASE + "/rest/v1/rpc/log_client_error", {
          method: "POST",
          headers: { "Content-Type": "application/json", "apikey": ANON, "Authorization": "Bearer " + ANON },
          body: body, keepalive: true, mode: "cors"
        }).catch(function () {}); // silence total : ne jamais reporter depuis le reporter
      } catch (e) { /* le collecteur ne casse jamais l'app */ }
    }
    window.__lncReport = report; // consommé par le hook ErrorBoundary (22-nav-error-bootstrap)

    // ── Chaînage défensif de window.onerror ──
    var prevOnError = window.onerror;
    window.onerror = function (message, source, lineno, colno, error) {
      try { report("error", (error && error.message) || message, { stack: error && error.stack, src: (source || "") + ":" + (lineno || 0) }); } catch (e) {}
      if (typeof prevOnError === "function") { try { return prevOnError.apply(this, arguments); } catch (e) {} }
      return false; // ne SUPPRIME pas le comportement par défaut (console reste)
    };
    // ── Chaînage défensif de onunhandledrejection ──
    var prevOnRej = window.onunhandledrejection;
    window.onunhandledrejection = function (ev) {
      try { var r = ev && ev.reason; report("unhandledrejection", (r && r.message) || String(r), { stack: r && r.stack }); } catch (e) {}
      if (typeof prevOnRej === "function") { try { return prevOnRej.apply(this, arguments); } catch (e) {} }
    };
  } catch (e) { /* jamais bloquer le boot */ }
})();


